import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class MacsIqViewConverter extends CmsConverterService<MacsIqViewData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const MACS_IQ_VIEW_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, MacsIqViewData>>('MacsIqViewConverter')

export type MacsIqViewData = ConvertedComponentData
